import {
    type LensSubmissionType,
    type LensstudioMylensesUpdate,
    type MylensesSubmissionDetailsSource,
} from "@snapchat/blizzard-schema";

export interface UpdateEventData {
    event: LensstudioMylensesUpdate["event_name"];
    source: MylensesSubmissionDetailsSource;
    lensSubmissionType: LensSubmissionType;
}

export const createUpdateEvent = ({ event, source }: UpdateEventData): LensstudioMylensesUpdate => ({
    event_name: event,
    event_value: source,
});
